@if (isVisible !== undefined && isVisible === true) {
  <div
    id="short-message"
    class="scheduler-message-content"
    [innerHTML]="content | schedulerMessageHtml"
  ></div>
}
